import { Settings } from "../../Settings";
import { ButtonColors, Panel } from "./panel";

const bluePanelColor: ButtonColors = {
    backgroundButtonColor: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206), rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
    linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%"
};

export class DefaultBluePanel extends Panel
{
    public override ConstructHtml(): void {
        if (Settings.EnablePanelWithSettings)
            {
                this.ConstructHtmlWithSettingsBtn()
                return;
            }
    }
    protected override ButtonBackground(): ButtonColors
    {
        return bluePanelColor;
    }
}